// extracted by mini-css-extract-plugin
export default {"button":"PearlButton_button__2SrrU","span":"PearlButton_span__8YniS","svg":"PearlButton_svg__O75rM","svgWrapper":"PearlButton_svgWrapper__7Pkoy"};